/**
 * Shared CTA helper: smooth-scrolls to the booking form on the current page
 * (looks for #book-form). If the page has no form, falls back to navigating
 * the user to /contact (which always has one).
 *
 * Designed to be used directly as an `onClick` for `<a href="#book-form">`,
 * with `navigate` taken from `useNavigate()` in the caller component.
 */
export function bookCtaClick(e, navigate) {
  const target = document.getElementById("book-form");
  if (target) {
    e.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    // keep focus accessible without scroll-jacking
    const firstInput = target.querySelector("input, select, textarea, button");
    if (firstInput) {
      setTimeout(() => firstInput.focus({ preventScroll: true }), 700);
    }
    // update URL hash for shareability without re-triggering scroll
    window.history.replaceState(null, "", "#book-form");
  } else {
    e.preventDefault();
    navigate("/contact#book-form");
  }
}
